function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import ImportModal from './ImportModal';
import { useSelector } from 'react-redux';
const HelpControls = _ref => {
  let {
    claim,
    importProps
  } = _ref;
  const [modalOpen, setModalOpen] = useState(false);
  const user = useSelector(state => state.auth.user);
  return /*#__PURE__*/React.createElement(React.Fragment, null, importProps ? /*#__PURE__*/React.createElement(ImportModal, _extends({}, importProps, {
    show: modalOpen,
    onHide: () => setModalOpen(false)
  })) : null, /*#__PURE__*/React.createElement(Row, {
    className: "pb-4"
  }, /*#__PURE__*/React.createElement(Col, {
    className: "text-end"
  }, user.account_type !== 'customer' && importProps ? /*#__PURE__*/React.createElement(Button, {
    className: "me-2",
    variant: "primary",
    disabled: claim.financials_locked || claim.is_locked,
    onClick: () => setModalOpen(true)
  }, "Import From Excel") : null)));
};
export default HelpControls;